export default {
    // récuperer toutes les typedepieces dans la base de données 
    get_all_typepieces(serverParams){
        return axios.post('/typepiece/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les typedepieces dans la base de données 
    post_typepiece(typedepiece){
        return axios.post('/typepieces',typedepiece, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_typepiece(libelle,typedepiece){
        return axios.post('/typepieces/'+libelle,typedepiece, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_typedepiece(libelle){
        return axios.get('/typepieces/'+libelle, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_typedepieces(id){
        return axios.delete('/typepieces/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}